import { Avatar, Divider, Menu, Space } from "antd";
import React, { useEffect, useState } from "react";
import { Container, Row } from "react-bootstrap";
import "./SideNavbar.css";
import "../../Assets/Css/Global.css";
import { Link, useHref, useLocation, useNavigate } from "react-router-dom";
import {
  adminItems,
  userItems,
  newUserItems,
} from "../../Assets/ListItems/SideNavbarMenu";
// import djtLogo from "../../Assets/Images/djtLogo.svg";

export default function SideNavbar({ type }) {
  const href = useHref();
  const location = useLocation(null);
  const navigate = useNavigate(null);

  const firstSegment = location.pathname.split("/")[1]; 

  const [currentKey, setCurrentKey] = useState("");
  const [openKeys, setOpenKeys] = useState([""]);

useEffect(() => {
  let newCurrentKey;
  const pathSegments = location.pathname.split('/').filter(Boolean); 
    // console.log(currentKey,pathSegments,'checkign curernt key')

  if (location.state?.selectedKey != null) {
    newCurrentKey = location.state.selectedKey;
  } else {
    let items;
    switch (type) {
      case 'admin':
        items = adminItems;
        break;
      case 'user':
        items = userItems;
        break;
      default:
        items = newUserItems;
    }

    const matchedItem = items.find(item => 
      pathSegments.some(segment => item.key.includes(segment))
    );

    newCurrentKey = matchedItem ? [matchedItem.key] : [firstSegment || ''];
  }

  const newOpenKeys = location.state?.openedKeys ?? [""];

  setCurrentKey(newCurrentKey);
  setOpenKeys(newOpenKeys);
}, [
  href, 
  type, 
  firstSegment, 
  location.state,
  location.pathname, 
  adminItems,       
  userItems,         
  newUserItems       
]);


  const onClick = (e) => {
    setCurrentKey(e.key);
    navigate(`/${type}/${e.key}`, {
      state: {
        selectedKey: e.key,
        openedKeys: [e.keyPath[1] !== undefined ? e.keyPath[1] : ""],
      },
    });
  };

  // console.log(currentKey,'checkign current ktye ')

  const onOpenChange = (keys) => {
    var i = keys.indexOf(openKeys[0]);
    if (i !== -1) {
      keys.splice(i, 1);
    }
    setOpenKeys(keys);
  };

  return (
    <div className="sideNavbar ">
      <Container className="p-0 ">
        <div className="flex justify-center items-center w-full bg-[#009BDE] h-[65px]">
          <div className="w-[220px] pt-2 pb-2 h-[65px] bg-[#009BDE]">
            <img
              src="/logo.png"
              alt="DJT Logo"
              className="w-full h-full object-contain"
            />
          </div>
        </div>

        <Menu
          className="custom-menu"
          mode="inline"
          selectedKeys={currentKey}
          onClick={onClick}
          openKeys={openKeys}
          onOpenChange={onOpenChange}
          style={{
            width: 232,
          }}
          items={
            type === "admin"
              ? adminItems
              : type === "user"
              ? userItems
              : newUserItems
          }
        />
      </Container>
    </div>
  );
}
